/**
 * Shared code between Griffin Node.js and Griffin client.
 *
 * Important: Do NOT include anything in here that isn't meant to be part of both libraries.
 */

"use strict";

/**
 * @name formatObscured
 * @param {integer} invisibleDigitsLength no. of obscure digits
 * @param {integer} firstVisibleDigitsLength no. of visible digits at the beginning
 * @param {string} non-obscured formattedPhoneNumber
 * @return {string} phone string formatted in national/international obscured style
 *
 * Helper function for special handling of national and international obscured formatting
 */
function formatObscured(
  invisibleDigitsLength,
  firstVisibleDigitsLength,
  formattedPhoneNumber
) {
  var regex = /\d/g,
    digitsCount = 0,
    st,
    en,
    result;
  while ((result = regex.exec(formattedPhoneNumber))) {
    digitsCount++;
    if (digitsCount === firstVisibleDigitsLength + 1) {
      st = result["index"];
    }
    if (digitsCount === firstVisibleDigitsLength + invisibleDigitsLength + 1) {
      en = result["index"];
    }
  }
  formattedPhoneNumber =
    formattedPhoneNumber.substring(0, st) +
    formattedPhoneNumber.replace(regex, "*").substring(st, en) +
    formattedPhoneNumber.substring(en);
  return "\u202a" + formattedPhoneNumber + "\u202c";
}

module.exports = {
  formatObscured: formatObscured
};
